<!-- Page Content -->
<main id="mainBodyContainer" class="container">
  <div class="col-md-8 col-12 mx-auto my-5 px-3">
      <h1 class="mb-3 mt-0">APA's Demographic Questionnaire</h1>

      <!-- Spinner -->
        <div *ngIf="loading$ | async" class="oauth-spinner">
        <div class="spinner"></div>
        <p>Connecting…</p>
        </div>

      <!-- ******************** BEGIN: MAIN PAGE CONTENT ******************** -->
      <div class="mb-0" *ngIf="!(loading$ | async)">
          <div id="intro" class="row" [hidden]="beginQuestionnaire">
              <div class="col-sm-12 py-3">
                  <div class="card mb-3">
                      <div class="card-body">
                          <div class="row">
                              <div class="col-12 px-4 pt-2">
                                  <div id="introduction" [hidden]="!showIntro">
                                      <p>
                                          As part of our ongoing Equity, Diversity, and Inclusion efforts, APA collects demographic information from users of Editorial Manager, including authors, reviewers, and editors. Please consider completing the following APA Journals demographic questionnaire. All items in the demographic questionnaire are optional. This information is securely housed in an APA database and will only be reported on as de-identified, aggregate data. Collecting this information allows APA to better measure the Journals program’s progress towards the commitments made in <a href="https://www.apa.org/about/apa/equity-diversity-inclusion/framework" target="_blank">APA’s EDI Framework</a> and in the organization’s <a href="https://www.apa.org/about/policy/dismantling-systemic-racism" target="_blank">resolution on psychology’s role in dismantling systemic racism</a>. 
                                      </p>
                                      <p> 
                                          *If you would prefer not to complete this questionnaire and would like to no longer receive prompts to do so, you can select <strong>"Prefer not to complete this questionnaire"</strong> below, and you will not receive any further automated prompts. If you choose to fill out the questionnaire in the future you will still be able to manually access the questionnaire using a link in your account.
                                      </p>
                                      <div class="row">
                                          <div class="col-12 pt-2 text-center mx-auto mb-3">
                                              <p class="mb-3">
                                                  <a href="#" (click)="decline()" id="decline">Prefer not to complete this questionnaire</a>
                                              </p>
                                              <button (click)="begin()" class="btn btn-pubs-2 mx-auto">Begin Questionnaire</button>
                                          </div>
                                      </div>
                                  </div>
                                  <div id="declinedQuestionnaire" [hidden]="!declineQuestionnaire">
                                      <p class="mb-0"> 
                                          You have declined to complete this questionnaire and will no longer receive any further automated prompts. Thank you for your time!
                                      </p>
                                      <p><strong>You can now close this window.</strong></p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="smartwizard" [hidden]="!beginQuestionnaire || submitted">
            <ul class="nav nav-progress" #navProgress [class.nav-progress-stuck]="navStuck">
                <li class="nav-item" *ngFor="let group of groups; let i = index">
                  <a
                    class="nav-link"
                    [ngClass]="{ active: currentStepIndex === i }"
                    (click)="goToStep(i)"
                    [attr.href]="'#step-' + (i + 1)"
                    [style.cursor]="navAllowed(i) ? 'pointer' : 'not-allowed'"
                  >
                    <div class="num" 
                    [ngClass]="{
                        'completed': completedSteps.includes(i),
                        'active-step': currentStepIndex === i
                      }">
                      {{ i + 1 }}
                    </div>
                    <span class="progressLabel">{{ group.name }}</span>
                  </a>
                  <div *ngIf="i < groups.length - 1" class="progress-line"  [ngClass]="{ 'filled': currentStepIndex > i }"></div>
                </li>
            </ul>
          
            <div class="tab-content">
              <div *ngFor="let group of groups; let i  = index">
                <div id="step-{{group.order}}" class="tab-pane" role="tabpanel" aria-labelledby="step-1" [hidden]="currentStepIndex != i">
                  <form class="p-0">
                      <div class="row">
                          <div class="col-sm-12">
                              <div class="card mb-3">
                                  <div class="card-header">
                                      <div class="row px-3 py-1">
                                          <h2 class="m-0 p-0">{{group.name}}</h2>
                                      </div>
                                  </div>
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <div class="mb-3">
                                                  <div class="row pb-3" *ngFor="let question of group.questions">
                                                    <div class="col-12" *ngIf="!question.text_value_answer">
                                                        <fieldset class="form-group">
                                                            <div class="form-row">
                                                                <div class="col-12">
                                                                    <legend class="mb-3">
                                                                        <p class="mb-0"><strong>{{question.text}}</strong></p>
                                                                        
                                                                    </legend>
                                                                    <div *ngFor="let option of question.options">
                                                                      <div *ngIf="question.multi_answer" class="form-check custom-control custom-checkbox mb-3">
                                                                          <div class="d-flex">
                                                                              <input type="checkbox" class="custom-control-input" [id]="'identity' + option.id" [name]="'identity' + option.id"
                                                                                [checked]="(answers[question.id] || []).includes(option.id)"
                                                                                (change)="onOptionSelect(question, option)"
                                                                              >
                                                                              <label class="custom-control-label ms-2" [for]="'identity' + option.id">{{option.text}}</label>
                                                                          </div>
                                                                      </div>
                                                                      <div *ngIf="!question.multi_answer" class="form-check custom-control custom-radio m-1 mb-3">
                                                                        <div class="d-flex">
                                                                            <input type="radio" class="custom-control-input" [id]="'gender' + option.id"
                                                                              [name]="'q' + question.id"
                                                                              [value]="option.id"
                                                                              (change)="onOptionSelect(question, option)"
                                                                              [checked]="(answers[question.id] || []).includes(option.id)">
                                                                            <label class="custom-control-label ms-2" [for]="'gender' + option.id">{{option.text}}</label>
                                                                        </div>
                                                                    </div>
                                                                    <div *ngIf="option.allow_text_value && (answers[question.id] || []).includes(option.id)" class="ms-4 mt-2 mb-3">
                                                                        <input type="text" class="form-control"
                                                                            [name]="'q' + question.id + '_text_' + option.id"
                                                                            [ngModel]="optionTextAnswers[option.id] ?? ''"
                                                                            (ngModelChange)="onOptionTextChange(option, $event)"
                                                                            placeholder="Feel free to provide more information in this optional text box"
                                                                            maxlength="255"
                                                                        >
                                                                    </div>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                        </fieldset>
                                                    </div>
                                                    <div class="col-12" *ngIf="group.name=='Education' && question.text_value_answer" [hidden]="!selectedEduDegree()">
                                                      <fieldset class="form-group">
                                                        <label for="degreeyear" class="mb-2"><strong>{{question.text}}</strong></label>
                                                        <select class="form-control" id="degreeyear"
                                                            [name]="'q' + question.id"
                                                            [(ngModel)]="selectedYear" 
                                                        >
                                                            <option value="" selected disabled>Choose Year...</option>
                                                            <option *ngFor="let year of years" [value]="year">{{year}}</option>
                                                        </select>
                                                      </fieldset>
                                                  </div>
                                                  <div class="col-12" *ngIf="group.name!='Education' && question.text_value_answer">
                                                      <fieldset class="form-group">
                                                        <label [for]="'q' + question.id" class="mb-2"><strong>{{question.text}}</strong></label>
                                                        <input type="text" class="form-control" [id]="'q' + question.id"
                                                            [name]="'q' + question.id"
                                                            [ngModel]="answers[question.id]?.[0] ?? ''"
                                                            (ngModelChange)="onTextAnswerChange(question, $event)"
                                                        >
                                                      </fieldset>
                                                  </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                        <div class="row">
                          <div [hidden]="currentStepIndex > 0">
                            <div class="d-flex flex-row justify-content-end px-3">
                                <div class="order-2 my-3 ps-sm-3">
                                    <button (click)="next()" class="btn btn-pubs-2 btn-responsive order-2 next-step" type="button">{{nextButtonText()}}</button>
                                </div>
                            </div>
                          </div>
                          <div [hidden]="currentStepIndex === 0">
                            <div class="d-flex flex-lg-row flex-column justify-content-between px-4" >
                              <div class="d-flex flex-row justify-content-start order-1">
                                  <div class="order-2 my-2 my-lg-3 pe-md-3 pe-0">
                                      <button (click)="prev()" class="btn btn-outline btn-responsive order-2 prev-step" type="button">{{prevButtonText()}}</button>
                                  </div>
                              </div>
                              <div class="d-flex flex-lg-row flex-column justify-content-end order-2">
                                  <div class="order-2 my-2 my-lg-3 ps-lg-3 ps-0">
                                      <button (click)="next()" class="btn btn-pubs-2 btn-responsive order-2 next-step" type="button">{{nextButtonText()}}</button>
                                  </div>
                              </div>
                          </div>
                        </div>
                        </div>
                  </form>
                </div>
              </div>
              
            </div>
          
          </div>
      </div>
  </div>
</main>

